import React, { memo, useCallback, useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom';
import { cacheKeys, localKeys } from '../constants/storageKeys';
import { message } from 'antd';

import { CONTEXT } from '../config';
import '../../node_modules/video-react/dist/video-react.css';
import { Player, ControlBar, BigPlayButton, Shortcut } from 'video-react';

import styles from './TopImgVideo.module.less';
import './animation.css';
import { logging } from '../actions/log';
import { logNative } from '../utils/utils';
import fail from '../static/msg-fail.svg';

const selectTopImgVideoVisible = createSelector(
  state => state.layout,
  layout => layout.topImgVideo,
);
export default memo(() => {
  const dispatch = useDispatch();
  const history = useHistory();
  const topImgVideo = useSelector(selectTopImgVideoVisible); // 头部图片视频

  const [player, setPlayer] = useState(null);
  /**
   * 初始化、和每次检查更新组件关闭时对比当前是否是最新版本独立包
   * 更新是否需要展示小红点
   */
  useEffect(() => {
    window.TopVideoPlayPause = (isPlay, isMute) => {
      if (player.actions) {
        player.actions.togglePlay();
        player.actions.mute(isMute);
      }
    };
  }, [player]);

  useEffect(() => {
    if (player) {
      player.subscribeToStateChange(e => {
        const { error } = e;
        if (error === 'UNKNOWN ERROR') {
          message.error({
            content: '视频播放失败',
            icon: <img className="ant-message-custom-img" src={fail} alt="fail" />,
          });
        }
        // setPause(paused);
      });
    }
  }, [player]);

  if (
    topImgVideo.page === 'detail' &&
    (history.location.pathname.indexOf(`${CONTEXT}/detail/soft`) > -1 ||
      history.location.pathname.indexOf(`${CONTEXT}/adetail`) > -1)
  ) {
    return (
      <div className={styles.img_video_detail} id="img_video_detail">
        {topImgVideo.data.showVideo === '1' ? (
          <>
            <div className="detail_video_bgbox">
              <img className="detail_video_bg" src={topImgVideo.data.coverImg} />
            </div>
            <div className="detail_video">
              <Player
                src={`${topImgVideo.data.videoUrl}`}
                poster={topImgVideo.data.coverImg}
                ref={p => setPlayer(p)}
                className={styles.player}
                playsInline={true}
                fluid={false}
                autoPlay={true}
                muted={true}
                loop={true}
                width={`100%`}
                height={`100%`}
              >
                <Shortcut clickable={false} dblclickable={false} />
                <BigPlayButton position="center" className={styles.player_btn} />
                <ControlBar
                  disableCompletely={true}
                  disableDefaultControls={true}
                  className={styles.player_controlbar}
                ></ControlBar>
              </Player>
            </div>
          </>
        ) : (
          <>
            <div className="detail_video_bgbox">
              <img className="detail_video_bg" src={topImgVideo.data.coverImg} />
            </div>
            <img className="detail_img" src={topImgVideo.data.coverImg} />
          </>
        )}
      </div>
    );
  }

  if (topImgVideo.page === 'special' && history.location.pathname === `${CONTEXT}/special`) {
    return (
      <div className={styles.img_video_special} id={'img_video_detail'}>
        <div className={'img_video_special_bgbox'}>
          <img src={topImgVideo.data.img} className="img_video_special_bg" />
        </div>
        <img src={topImgVideo.data.img} className="detail_img" />
      </div>
    );
  }
  return '';
});
